<template>
  <div class="recyclerList">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="回收员数据管理" name="first">
        <div class="search_wrap">
          <el-form
            :model="queryParam"
            ref="form"
            label-width="80px"
            :inline="true"
            size="mini"
          >
            <el-form-item label="姓名">
              <el-input
                v-model="queryParam.name"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchQuery('1')"
                >查询</el-button
              >
              <el-button type="primary" @click="clearsearchQuery"
                >重置</el-button
              >
              <el-button type="primary" @click="exportStreet">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="statistics">
          <div>
            <p>完成率</p>
            <p>{{ allData.complateRate }}%</p>
            <p>{{ allData.complateOrder }}/{{ allData.totalOrder - allData.cancelCount }}</p>
          </div>
          <div>
            <p>取消率</p>
            <p>{{ allData.cancelRate }}%</p>
            <p>{{ allData.cancelCount }}/{{ allData.totalOrder }}</p>
          </div>
          <div>
            <p>准点率</p>
            <p>{{ allData.onTimeRate }}%</p>
            <p>{{ allData.onTimeCount }}单准时</p>
            <p>{{ allData.delayCount }}单延误</p>
          </div>
          <div>
            <p>满意度</p>
            <p>{{ allData.pleasedRate }}%</p>
            <p>{{ allData.commentCount }}人参与评价</p>
            <p>共{{ allData.totalCommentScore }}分</p>
          </div>
        </div>
        <div class="table_div">
          <el-table
            :data="DataList"
            border
            :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
            :default-expand-all="false"
            style="width: 100%"
          >
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="orderCount" label="订单数"></el-table-column>
            <el-table-column
              prop="pendingCount"
              label="待完成"
            ></el-table-column>
            <el-table-column
              prop="recallCount"
              label="已撤回次数"
            ></el-table-column>
            <el-table-column
              prop="recallWeight"
              label="已撤回重量"
            ></el-table-column>
            <el-table-column
              prop="signOrderCount"
              label="签收订单数"
            ></el-table-column>
            <el-table-column
              prop="signWeight"
              label="签收重量"
            ></el-table-column>
            <el-table-column
              prop="signCoin"
              label="签收环保金"
            ></el-table-column>
            <el-table-column prop="onTimeRate" label="准点率"></el-table-column>
            <el-table-column
              prop="pendingCount"
              label="待完成"
            ></el-table-column>
            <el-table-column
              prop="commentCount"
              label="点评数"
            ></el-table-column>
            <el-table-column
              prop="commentRate"
              label="点评率"
            ></el-table-column>
            <el-table-column
              prop="goodCommentRate"
              label="好评率"
            ></el-table-column>
            <el-table-column prop="wlUserId" label="用户ID"></el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChangerecycler"
            @current-change="handleCurrentChangerecycler"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="回收员管理" name="second">
        <div class="search_wrap">
          <el-form
            :model="queryParam"
            ref="form"
            label-width="100px"
            :inline="true"
            size="mini"
          >
            <el-form-item label="回收员名称">
              <el-input
                v-model="queryParam.name"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchQuery('2')"
                >查询</el-button
              >
              <el-button type="primary" @click="clearsearchQuery"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="add">
          <el-button type="primary" @click="addRecycler('add')"
            >新增回收员</el-button
          >
        </div>
        <div class="table_div">
          <el-table
            :data="recycleList"
            border
            :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
            :default-expand-all="false"
            style="width: 100%"
          >
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
            <el-table-column
              prop="communityCount"
              label="区域数量"
            ></el-table-column>
            <el-table-column width="230px" label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="addRecycler('edit', scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  @click="addRecycler('query', scope.$index, scope.row)"
                  >详情</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChangerecycler"
            @current-change="handleCurrentChangerecycler"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <recyclertAddEdit
        @saveSubmit="saveSubmit"
        :recycleData="recycleData"
        :isQuery="isQuery"
        v-if="drawer"
      ></recyclertAddEdit>
    </el-drawer>
  </div>
</template>

<script>
import {
  recycleUserdata,
  recycleUserdatadetail,
  recycleUserlist,
  recycleUserdetail,
  recyclesave,
  recycleUserdelete,
} from "@/api/management";
import recyclertAddEdit from "./component/recyclertAddEdit.vue";
import { publicMixin } from "@/mixins/publicMixin";
export default {
  name: "recyclerList",
  components: { recyclertAddEdit },
  mixins: [publicMixin],
  props: {},
  data() {
    return {
      activeName: "first",
      drawer: false,
      title: "",
      isQuery: false,
      allData: {},
      recycleData: {},
      queryParam: {
        name: "",
      },
      
      recycleList: [],
      DataList: [],
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getrecycleUserdata();
    this.getrecycleUserdatadetail();
  },
  methods: {
    saveSubmit(params) {
      recyclesave(params).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.$message.success("操作成功");
            this.drawer = false;
            this.currentPage = 1;
            this.getrecycleUserlist();
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSizeChangerecycler(val) {
      // 改变每页显示的条数
      this.PageSize = val;
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1;
      if (this.activeName == "first") {
        this.getrecycleUserdata();
      } else {
        this.getrecycleUserlist();
      }
    },
    // 显示第几页
    handleCurrentChangerecycler(val) {
      // 改变默认的页数
      this.currentPage = val;
      if (this.activeName == "first") {
        this.getrecycleUserdata();
      } else {
        this.getrecycleUserlist();
      }
    },
    clearsearchQuery() {
      for (let key in this.queryParam) {
        this.queryParam[key] = "";
      }
      // 默认显示第几页
      this.currentPage = 1;
      this.PageSize = 10;
    },
    handleClick(tab) {
      console.log(tab.name);
      this.clearsearchQuery();
      if (tab.name == "first") {
        this.getrecycleUserdata();
        this.getrecycleUserdatadetail();
      } else {
        this.getrecycleUserlist();
      }
    },
    getrecycleUserlist() {
      // let obj = JSON.parse(JSON.stringify(this.queryParam))
      console.log(this.PageSize);
      let obj = {};
      obj.pageNo = this.currentPage;
      obj.pageSize = this.PageSize;
      obj.name = this.queryParam.name;
      recycleUserlist(obj).then((res) => {
        if (res.code == 200) {
          this.totalCount = res.data.total;
          this.currentPage = res.data.current;
          this.PageSize = res.data.size;
          this.recycleList = res.data.records;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getrecycleUserdatadetail() {
      recycleUserdatadetail({}).then((res) => {
        if (res.code == 200) {
          this.allData = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getrecycleUserdata() {
      // let obj = JSON.parse(JSON.stringify(this.queryParam))
      let obj = {};
      obj.pageNo = this.currentPage;
      obj.pageSize = this.PageSize;
      obj.name = this.queryParam.name;
      recycleUserdata(obj).then((res) => {
        if (res.code == 200) {
          this.totalCount = res.data.total;
          this.currentPage = res.data.current;
          this.PageSize = res.data.size;
          this.DataList = res.data.records;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    addRecycler(where, index, row) {
      this.drawer = true;
      this.isQuery = false;
      if (where == "add") {
        this.title = "新增回收员";
      } else {
        this.title = "编辑回收员";
        if (where == "query") {
          this.title = "回收员详情";
          this.isQuery = true;
        }
        let item = row;
        let obj = {};
        obj.id = item.id;
        recycleUserdetail(obj).then((res) => {
          if (res.code == 200) {
            this.recycleData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    handleDelete(index, row) {
      this.$confirm("正在执行删除操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        recycleUserdelete({ id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.currentPage = 1;
            this.getrecycleUserlist();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    searchQuery(num) {
      this.currentPage = 1;
      if (num == "1") {
        this.getrecycleUserdata();
      } else {
        this.getrecycleUserlist();
      }
    },
    exportStreet() {
      let exportXlsUrl = "recycleUser/data/list/export";
      let fileName = "回收员数据导出";
      let obj = {};
      obj = JSON.parse(JSON.stringify(this.queryParam));
      obj.pageNo = '1';
      obj.pageSize = '99999';
      this.export(exportXlsUrl, obj, fileName);
    },
  },
};
</script>
<style lang="scss" scoped>
.recyclerList {
  padding: 18px;
  .search_wrap {
    margin-top: 20px;
  }
  .statistics {
    width: 550px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    div {
      width: 120px;
      border-radius: 12px;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
  .add {
    margin-top: 20px;
  }
  .table_div {
    margin-top: 20px;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
